import { render, staticRenderFns } from "./iamVote.vue?vue&type=template&id=207891f6&scoped=true&"
import script from "./iamVote.vue?vue&type=script&lang=js&"
export * from "./iamVote.vue?vue&type=script&lang=js&"
import style0 from "./iamVote.vue?vue&type=style&index=0&id=207891f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207891f6",
  null
  
)

export default component.exports